<div
  class="ride-card"
  role="button"
  tabindex="0"
  aria-label="Rit openen"
  [style.border-left-color]="getRideColor()"
  (click)="onItemClick()"
  (keydown.enter)="onItemClick()"
  (keydown.space)="$event.preventDefault(); onItemClick()"
>
  <div class="ride-content">
    <div class="passenger-section">
      <h4 class="passenger-name">
        @if (!ride().rejected && !ride().planningCompleted && ride()?.hasCopy) {
          <mat-icon matTooltip="Deze rit zit in een reeks">repeat</mat-icon>
        }
        @if (ride()?.isRetour) {
          <mat-icon matTooltip="Dit is een retourrit">fast_rewind</mat-icon>
        }
        {{ ride()?.passenger.title }}
      </h4>
      @if (ride()?.passenger.phoneNumber) {
        <span class="passenger-phone">({{ ride().passenger.phoneNumber }})</span>
      }
    </div>

    <div class="location-section">
      <div class="location-item">
        <span class="location-label">Van:</span>
        <mat-icon class="location-icon">place</mat-icon>
        <span class="location-text">{{ ride()?.passenger?.from?.address ?? ride()?.passenger?.from }}</span>
      </div>
      <div class="location-item">
        <span class="location-label">Naar:</span>
        <mat-icon class="location-icon">place</mat-icon>
        <span class="location-text">{{ ride()?.passenger?.to?.address ?? ride()?.passenger?.to }}</span>
      </div>
    </div>

    <div class="time-section">
      <div class="time-item">
        <span class="time-label">Begintijd:</span>
        <span class="time-value">{{ moment(ride()?.start.toDate()).format('HH:mm') }}</span>
      </div>
      @if (ride()?.specifyDropoffTime === true) {
        <div class="time-item">
          <span class="time-label">Eindtijd:</span>
          <span class="time-value">{{ moment(ride()?.end.toDate()).format('HH:mm') }}</span>
        </div>
      }
    </div>

    <div class="edit-section">
      <button mat-icon-button aria-label="Rit bewerken">
        <mat-icon>{{ ride().rejected ? 'calendar_today' : 'edit' }}</mat-icon>
      </button>
      @if (ride().rejected) {
        <button
          mat-icon-button
          aria-label="Restrit verwijderen"
          (click)="onDeleteClick(); $event.stopPropagation()"
          matTooltip="Restrit verwijderen"
        >
          <mat-icon>delete</mat-icon>
        </button>
      }
    </div>
  </div>

  @if (ride()?.passenger.particularityIds && ride()?.passenger.particularityIds.length > 0) {
    <div class="particularities-section">
      @for (particularity of particularities; track particularity.id) {
        @if (ride().passenger?.particularityIds?.includes(particularity.id)) {
          <div class="icon" [matTooltip]="particularity.name">
            <mat-icon [svgIcon]="particularity.id"></mat-icon>
          </div>
        }
      }
    </div>
  }

  @if (ride()?.passenger.remarks) {
    <div class="comment-section">
      <span class="comment-label">Opmerking (Planner):</span>
      <span class="comment-text">{{ ride().passenger.remarks }}</span>
    </div>
  }
</div>
